var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.comingSoon)?_vm._t("default",[_c('nuxt'),_vm._v(" "),(!_vm.hideFooter)?_c('app-footer'):_vm._e()]):_vm._t("default",[_c('holding-page')])],2)}
var staticRenderFns = []

export { render, staticRenderFns }